import { StakeInputError, StakeInputErrors, TotalStakeError, TotalStakeErrors } from '../types';
import {
    StakeInputValidator,
    TotalStakeValidator,
    ValidatorMap,
    validateAboveMax,
    validateAll,
    validateTotalStakeAll,
    validateWalletCashBalance,
} from './validators';

export const MIN_COINS_STAKE = 100;

const validateBelowMinCoinsStake = ({ betStake }: StakeInputValidator) => betStake >= MIN_COINS_STAKE;

const validateDecimalsNotAllowed = ({ betStake }: StakeInputValidator) => !betStake.toString().includes('.');

export const coinsValidateSingleEntryWalletBalance = ({ betStake, walletCashBalance }: StakeInputValidator) =>
    betStake <= walletCashBalance;

type CoinsTotalStakeError = Extract<TotalStakeError, 'EXCEED_WALLET_CASH_BALANCE'>;

export const coinsTotalStakeValidators: ValidatorMap<CoinsTotalStakeError, TotalStakeValidator> = {
    [TotalStakeErrors.ExceedWalletCashBalance]: {
        validate: validateWalletCashBalance,
        translationKey: 'exceed_wallet_balance_error',
    },
};

const coinsTotalStakeValidationOrder: Array<CoinsTotalStakeError> = [TotalStakeErrors.ExceedWalletCashBalance];

type CoinsStakeInputError = Extract<
    StakeInputError,
    'EXCEED_SINGLE_WALLET_BALANCE' | 'BELOW_MIN' | 'ABOVE_MAX' | 'DECIMALS_NOT_ALLOWED'
>;

export const coinsStakeInputValidators: ValidatorMap<CoinsStakeInputError, StakeInputValidator> = {
    [StakeInputErrors.ExceedSingleWalletBalance]: {
        validate: coinsValidateSingleEntryWalletBalance,
        translationKey: 'entry_exceed_wallet_balance_error',
    },
    [StakeInputErrors.BelowMin]: {
        validate: validateBelowMinCoinsStake,
        translationKey: 'entry_below_min_error',
    },
    [StakeInputErrors.AboveMax]: {
        validate: validateAboveMax,
        translationKey: 'entry_above_max_error',
    },
    [StakeInputErrors.DecimalsNotAllowed]: {
        validate: validateDecimalsNotAllowed,
        translationKey: 'entry_decimals_not_allowed_error',
    },
};

const coinsStakeInputValidationOrder: Array<CoinsStakeInputError> = [
    StakeInputErrors.ExceedSingleWalletBalance,
    StakeInputErrors.AboveMax,
    StakeInputErrors.BelowMin,
    StakeInputErrors.DecimalsNotAllowed,
];

export const validateCoinsInput = (inputs: StakeInputValidator) => {
    return validateAll<StakeInputValidator, CoinsStakeInputError>(
        inputs,
        coinsStakeInputValidators,
        coinsStakeInputValidationOrder
    );
};

export const validateCoinsTotalStake = (inputs: TotalStakeValidator) =>
    validateTotalStakeAll<TotalStakeValidator, CoinsTotalStakeError>(
        inputs,
        coinsTotalStakeValidators,
        coinsTotalStakeValidationOrder
    );
